export const FieldError = ({
  errorText
}) => <div className="input-fields__error field-error--wrap">
    <i className="input-fields__error-icon icon--solid foundry-icon icon--exclamation-triangle icon--red field-error--icon"></i>
    <span className="input-fields__error-message field-error--message">
      {errorText}
    </span>
  </div>;